import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Select from 'components/Select'
import SelectWithCheckBox from 'components/SelectWithCheckBox/index'
import { FormItem } from 'components/UIComponents/FormStyles/index'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import Toggle from 'components/UIComponents/Toggle'
import { columnData } from 'modules/Exp-Candidates/DownloadAndUpload/DownloadCandidateDrawer/Constant'
import {
  FooterFlex,
  Label,
} from 'modules/Exp-Candidates/DownloadAndUpload/DownloadCandidateDrawer/style'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { downloadAttachment } from 'utils/downloadAttachment'
import SuccessMessage from 'utils/SuccessMessage'

const DownLoadCandidate = ({
  downloadCand,
  setDownloadcand,
  driveRoleList = [],
  selectedRoleId,
  setSelectedRoleId,
  roundList,
  downloadCandidate,
  driveId,
  setIsDrawer,
  noNeedRole,
  roleId,
  stage,
}) => {
  const dispatch = useDispatch()
  const [selectedFileType, setSelectedFileType] = useState('xlsx')
  const [selectedRound, setSelectedRound] = useState('')
  const [selectedColumn, setSelectedColumn] = useState([])
  const [loading, setLoading] = useState(false)

  const onClose = () => {
    setDownloadcand(false)
    setIsDrawer(true)
    setSelectedFileType('xlsx')
    setSelectedRoleId(noNeedRole ? roleId : driveRoleList[0]?.roleId)
    setSelectedRound('')
    setSelectedColumn([])
  }

  const onDownload = async () => {
    setLoading(true)
    let response = await dispatch(
      downloadCandidate(
        driveId,
        selectedRoleId,
        selectedFileType,
        selectedRound,
        selectedColumn
      )
    )
    if (response?.status >= 200 && response?.status <= 300) {
      downloadAttachment(response?.data?.data?.url)
      setLoading(false)
      SuccessMessage('Candidate list downloaded successfully!')
      onClose()
    } else {
      ErrorMessage(response?.response?.data?.message)
      setLoading(false)
    }
  }
  useEffect(() => {
    if (stage != 'all_candidates') {
      setSelectedRound(stage)
    }
  }, [stage])
  const content = () => {
    return (
      <>
        <FormItem marginbottom={'30px'}>
          <Label>Choose Format</Label>
          <Toggle
            left="(.xlsx)"
            right="(.csv)"
            onClick={e => setSelectedFileType(e ? 'csv' : 'xlsx')}
            initialValue={selectedFileType === 'xlsx' ? 'left' : 'right'}
          />
        </FormItem>

        {!noNeedRole && (
          <FormItem marginbottom={'30px'}>
            <Label>Choose Role</Label>
            <Select
              value={selectedRoleId}
              showSearch={true}
              OptionData={driveRoleList}
              filterOption={false}
              valueParam="roleId"
              right
              nameParam="roleName"
              placeholder="Eg. Software Engineer"
              onChange={value => setSelectedRoleId(value)}
              id={'download_role'}
            />
          </FormItem>
        )}

        <FormItem marginbottom={'30px'}>
          <Label>Choose Interview Round </Label>
          <Select
            value={selectedRound}
            showSearch={true}
            OptionData={roundList[0]?.rounds
              .slice(0, roundList[0]?.rounds?.length - 1)
              .filter(round => round.count > 0)}
            filterOption={false}
            valueParam="roundName"
            nameParam="roundName"
            placeholder="Eg. Technical"
            onChange={value => setSelectedRound(value)}
            id={'download_round'}
          />
        </FormItem>

        <FormItem marginbottom={'30px'}>
          <Label>Choose Columns to be added in the Excel </Label>
          <SelectWithCheckBox
            value={selectedColumn}
            optionLabelProp={'label'}
            placeholder={'Eg. ID'}
            onChange={value => setSelectedColumn(value)}
            optionDivData={columnData}
            selectedValue={selectedColumn}
            maxTagCount={3}
            getPopupContainer={() => document.getElementById('download_round')}
          />
        </FormItem>
      </>
    )
  }
  const footer = () => {
    return (
      <FooterFlex flexEnd centerVertically>
        <Button.Secondary width="88px" text="Cancel" onClick={onClose} />
        <Button.Primary
          width="110px"
          text="Download"
          loading={loading}
          onClick={onDownload}
        />
      </FooterFlex>
    )
  }
  return (
    <Drawer
      width="40%"
      title={'Download Candidate List'}
      placement="right"
      visible={downloadCand}
      content={content()}
      footer={footer()}
      onClose={onClose}
      closable
    />
  )
}

export default DownLoadCandidate
